module.exports = __webpack_public_path__ + "static/media/pentalog.d62b64b1.png";